import React, { useState } from "react";
import "./RadioInputSelection.css";
import { configShop } from '../../states/configShop';
// import styled from "styled-components";

const RadioInputSeleccion = ({
  tituloTopping,
  codigoCurrency,
  codigoPais,
  guardarToppingsSeleccionados,
}) => {
  const { dataConfig } = configShop();
  // toppings_groups = tituloTopping
  const [toppingsSeleccionados, setToppingsSeleccionados] = useState();
  console.log();
  const [informacionItem, setInformacionItem] = useState();

  const [isBotonActive, setIsBotonActive] = useState(false);

  const actualizarValorSeleccionado = (
    indexExterno,
    indexInterno,
    isChecked
  ) => {
    // indexExterno: index de la categoria Ejem: Bebidas
    //indexInterno: index del toping seleccionado ejem: Coca cola
    // console.log("actualizarValorSeleccionado ");

    let categoriaSeleccionada = tituloTopping[indexExterno];
    let toppingSeleccionado = categoriaSeleccionada.toppings[indexInterno];

    if (toppingsSeleccionados !== undefined) {
      // console.log("toppingsSeleccionados ");
      //verifica si la categoria del topping seleccionado existe en el set

      let filtro = toppingsSeleccionados.filter(
        (categoria) => categoria.name === categoriaSeleccionada.name
      );

      let categoria = filtro[0];
      //Si no existe se crea el objeto y se agrega al set
      if (categoria === undefined) {
        const topingsXCategoria = {
          uuid: categoriaSeleccionada.uuid,
          name: categoriaSeleccionada.name,
          topingsSeleccionados: [toppingSeleccionado],
        };
        guardarToppingsSeleccionados([
          ...toppingsSeleccionados,
          topingsXCategoria,
        ]);
        // agrega un nuevo item a un array, se esta creando un nuevo array con la informacion anterior mas el item agregado.
        setToppingsSeleccionados([...toppingsSeleccionados, topingsXCategoria]);
      } else {
        // Si existe la categoria se agrega el nuevo toping al array de topings de la categoria
        //Actualizar la lista de topings seleccionados con los nuevos valores
        // console.log("categoriaSeleccionada " + categoriaSeleccionada );
        // Aqui entra y funciona como radio bottom
        if (
          categoriaSeleccionada.type === 0 &&
          categoriaSeleccionada.cant_max === 1
        ) {
          const newState = toppingsSeleccionados.map((obj) => {
            if (obj.name === categoriaSeleccionada.name) {
              return {
                uuid: categoriaSeleccionada.uuid,
                name: categoriaSeleccionada.name,
                topingsSeleccionados: [toppingSeleccionado],
              };
            }
            return obj;
          });
          guardarToppingsSeleccionados(newState);
          setToppingsSeleccionados(newState);
        } else {
          if (isChecked === true) {
            // si el topping esta seleccionado toca eliminarlo de la lista.
            const newState = toppingsSeleccionados.map((obj) => {
              if (obj.name === categoriaSeleccionada.name) {
                // este filtro crea un array con todos los tippings menos el que se esta seleccionando.
                var listaToppings = obj.topingsSeleccionados.filter((item) => {
                  return item.name !== toppingSeleccionado.name;
                });

                return {
                  uuid: categoriaSeleccionada.uuid,
                  name: categoriaSeleccionada.name,
                  topingsSeleccionados: listaToppings,
                };
              }
              return obj;
            });
            guardarToppingsSeleccionados(newState);
            setToppingsSeleccionados(newState);
          } else {
            const newState = toppingsSeleccionados.map((obj) => {
              if (obj.name === categoriaSeleccionada.name) {
                return {
                  uuid: categoriaSeleccionada.uuid,
                  name: categoriaSeleccionada.name,
                  topingsSeleccionados: [
                    ...obj.topingsSeleccionados,
                    toppingSeleccionado,
                  ],
                };
              }
              return obj;
            });
            guardarToppingsSeleccionados(newState);
            setToppingsSeleccionados(newState);
          }
        }
      }
    } else {
      const topingsXCategoria = {
        uuid: categoriaSeleccionada.uuid,
        name: categoriaSeleccionada.name,
        topingsSeleccionados: [toppingSeleccionado],
      };
      guardarToppingsSeleccionados([topingsXCategoria]);
      setToppingsSeleccionados([topingsXCategoria]);
    }
  };

  const btnColor = dataConfig?.page_menu?.button?.color ?? "#000";
  const btnTextColor = dataConfig?.page_menu?.button?.color_text ?? "#fff";

  return (
    <>
      {tituloTopping.map((titulo, indexExterno) => {
        var categoriaGuardada;
        var desabilitarCheckbox = false;
        if (toppingsSeleccionados !== undefined) {
          let filtro = toppingsSeleccionados.filter(
            (categoria) => categoria.name === titulo.name
          );
          categoriaGuardada = filtro[0];
        }
        if (categoriaGuardada !== undefined) {
          if (categoriaGuardada.topingsSeleccionados.length === titulo.cant_max) {
            desabilitarCheckbox = true;
          }
        }

        return (
          <React.Fragment key={titulo.uuid}>
            <div
              className="subtitulosOpciones"
              style={{ "--topping-color": btnColor, "--topping-text-color": btnTextColor }}
            >
              <h3 className="titulo-categoria">{titulo.name}</h3>
              <div className="contenedor-cantidades">
                <p className="pill-minmax">Mín {titulo.cant_min} · Máx {titulo.cant_max}</p>
                {titulo.cant_min > 0 && (
                  <p className="pill-obligatorio">Obligatorio</p>
                )}
              </div>
            </div>

            {titulo.toppings?.map((opciones, indexInterno) => {
              const esRadio = titulo.type === 0 && titulo.cant_max === 1;

              var isChecked = false;
              if (!esRadio && categoriaGuardada !== undefined) {
                let filtro = categoriaGuardada.topingsSeleccionados.filter(
                  (topping) => topping.name === opciones.name
                );
                if (filtro[0] !== undefined) isChecked = true;
              }

              const inputId = (esRadio ? "radio-" : "checkbox-") + opciones.uuid;

              return (
                <React.Fragment key={opciones.uuid}>
                  <div
                    className="fila-option-detalle-alternativo"
                    style={{ "--topping-color": btnColor, "--topping-text-color": btnTextColor }}
                  >
                    <label className="options-comida" htmlFor={inputId}>
                      <span>{opciones.name}</span>
                      <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span className="precio-topping">
                          +{opciones.price.toLocaleString(codigoPais, {
                            style: "currency",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                            currency: codigoCurrency,
                          })}
                        </span>
                        {esRadio ? (
                          <input
                            id={inputId}
                            type="radio"
                            name={titulo.uuid}
                            className="custom-input"
                            value={informacionItem}
                            onChange={() => actualizarValorSeleccionado(indexExterno, indexInterno)}
                          />
                        ) : (
                          <input
                            id={inputId}
                            type="checkbox"
                            className="custom-input"
                            name={titulo.name}
                            value={informacionItem}
                            checked={isChecked}
                            onChange={() => actualizarValorSeleccionado(indexExterno, indexInterno, isChecked)}
                            disabled={isChecked ? false : desabilitarCheckbox}
                          />
                        )}
                      </span>
                    </label>
                  </div>
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default RadioInputSeleccion;
